import { useSelectIsAppModeNewportSingleWidget } from 'app/store/general/selectors';
import { useWidgetContext } from 'widgets/WidgetContext';

export function useTileInNewportSingleWidgetMode() {
    const { host } = useWidgetContext();
    const isAppModeNewportSingleWidget =
        useSelectIsAppModeNewportSingleWidget();
    return host !== 'tile' && isAppModeNewportSingleWidget;
}
